import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleInfo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-info, comment, feedback"><path d="M12 14.25V10.25M3.75 3.75H20.25V18.25H15.0155L11.9979 20.75L9.0155 18.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 8.5H12.75V7H11.25V8.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleInfo;
